import { Button, LogoVertical } from "@datapay-by-datacom/design-system";
import styles from "./Login.module.css";
import { AppState } from "@auth0/auth0-react";
import { useState } from "react";
import { getBrandName, getLogoUrl } from "../../brand-config";

interface LoginProps {
  loginWithRedirect: (state?: { appState?: AppState }) => void;
}

export function Login({ loginWithRedirect }: LoginProps) {
  const [error, setError] = useState<string | undefined>();

  return (
    <LoginScreen error={error}>
      <LoginButton loginWithRedirect={loginWithRedirect} setError={setError} />
    </LoginScreen>
  );
}

function LoginButton({
  loginWithRedirect,
  setError,
}: {
  loginWithRedirect: (state?: { appState?: AppState }) => void;
  setError: (error: string) => void;
}) {
  const searchParams = new URLSearchParams(window.location.search);
  const isContinueFromMagicLink = searchParams.has("code");

  async function handleLogin() {
    try {
      await loginWithRedirect({ appState: { returnTo: window.location.href } });
    } catch (error) {
      setError((error as Error).message);
      console.error(error);
    }
  }
  return (
    <Button width="stretch" size="large" onPress={handleLogin}>
      {isContinueFromMagicLink ? "Continue Login" : "Login"}
    </Button>
  );
}

export function LoginLoading() {
  return (
    <LoginScreen>
      <Button width="stretch" size="large" variant="secondary" isDisabled>
        Loading...
      </Button>
    </LoginScreen>
  );
}

interface LoginScreenProps {
  children: React.ReactNode;
  error?: string;
}

function LoginScreen({ children, error }: LoginScreenProps) {
  const logoUrl = getLogoUrl();
  return (
    <div className={styles.container}>
      {logoUrl ? (
        <img src={logoUrl} alt={getBrandName()} className={styles.logo} />
      ) : (
        <LogoVertical />
      )}
      <span className={styles.title}>Payroll Assistant</span>
      <span className={styles.subtitle}>Powered by {getBrandName()}</span>
      <div className={styles.login}>{children}</div>
      {error && <div className={styles.error}>{error}</div>}
    </div>
  );
}
